/* tps-setup.js · PDP "Complete your setup" (release 1, 7 Oct 2026; snippets/tps-setup.liquid, Midas spec design/pdp-setup-up).
   Loaded (deferred) only when the panel renders. One /cart/add.js items[] call: the main variant x Dial qty (unless it was
   already added this page view, or is sold out) plus every ticked extra, then the THEME drawer renders from the response
   (fallback /?sections=, as tps-addwith.js). Unit prices come from the variants JSON and data-setup-price, never from the
   tweening [data-atc-price] text. Exact total, set at once (no count-up). A 422 on any line fails the whole call: "Try again",
   ticks unchanged. Stamp: tps:src "setup" (a count only). One timer per button. */
(function (d) {
  var box = d.querySelector('[data-setup]'); if (!box) return;
  /* Add-ons in the box (founder 17 Oct; snippets/tps-setup mode 'box'). No button of its own: assets/pdpv9.js reads
     root.__tpsExtras on Add to cart (one /cart/add.js call: ticked extras x1 + the main item x the Dial) and on every price
     roll (the button total includes the ticks). Rows start unticked. In cart = disabled, unticked, "In cart" (same /cart.js
     sync as the panel). Telemetry per TELEMETRY-R1: setup_view once when the block is on screen (n = rows); setup_add after a
     successful add that carried at least one extra (hs/ps of the extras that reached the cart, nt, ns = rows not in cart, m 1).
     A plain Add to cart with nothing ticked is not a setup add. */
  if (box.hasAttribute('data-setup-box')) {
    var R = box.closest('.pdpv9') || d, C = [].slice.call(box.querySelectorAll('.setup-cb')), V = 0, Q = 0;
    var P = function (n, o) { var A = window.Shopify && Shopify.analytics; if (A && A.publish) try { A.publish(n, o); } catch (x) {} };
    var on = function () { return C.filter(function (c) { return c.checked && !c.disabled; }); };
    var rp = function () { if (typeof R.__tpsAtcRepaint === 'function') R.__tpsAtcRepaint(); };
    C.forEach(function (c) { var p = c.parentNode.querySelector('.setup-p'); c._p = p ? p.textContent : ''; c._l = c.getAttribute('aria-label'); });
    R.__tpsExtras = {
      cents: function () { return on().reduce(function (a, c) { return a + (+c.getAttribute('data-setup-price') || 0); }, 0); },
      items: function () { return on().map(function (c) { return { id: +c.getAttribute('data-setup-id'), c: c }; }); },
      done: function (r) {
        var ok = (r && r.ok) || [], bad = (r && r.bad) || [], ns = C.filter(function (c) { return !c.disabled; }).length;
        if (ok.length) {
          P('setup_add', { hs: ok.map(function (x) { return x.c.getAttribute('data-h'); }), ps: ok.map(function (x) { return C.indexOf(x.c) + 1; }), nt: ok.length, ns: ns, m: 1 });
          try { d.dispatchEvent(new CustomEvent('tps:src', { detail: 'setup' })); } catch (x) {}
        }
        C.forEach(function (c) { c.checked = false; }); rp();
        if (!bad.length) return '';
        var nm = bad.map(function (x) { var n = x.c.parentNode.querySelector('.sbx-n'); return n ? n.textContent.trim() : 'One item'; });
        return 'Added. ' + nm.join(', ') + (nm.length > 1 ? ' could not be added. They may have just sold out.' : ' could not be added. It may have just sold out.');
      }
    };
    box.addEventListener('change', rp);
    var mk = function (ids) {
      C.forEach(function (c) {
        var inc = ids[+c.getAttribute('data-setup-id')] === 1, p = c.parentNode.querySelector('.setup-p');
        if (inc === c.disabled) return;
        c.disabled = inc; c.checked = false; c.parentNode.classList.toggle('is-in', inc);
        if (p) p.textContent = inc ? 'In cart' : c._p;
        c.setAttribute('aria-label', inc ? c._l.replace(/, [^,]*$/, '') + ', in cart' : c._l);
      });
      rp();
    };
    var sy = function () {
      clearTimeout(Q); Q = setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (c) { var ids = {}; (c.items || []).forEach(function (i) { ids[i.variant_id] = 1; }); mk(ids); })
          .catch(function () {});
      }, 350);
    };
    d.addEventListener('tps:src', sy); d.addEventListener('variant:add', sy); d.addEventListener('cart:refresh', sy);
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, sy); } catch (x) {}
    sy();
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { if (e[e.length - 1].isIntersecting && !V++) P('setup_view', { n: C.length }); }).observe(box);
    return;
  }
  var root = box.closest('.pdpv9') || d, go = box.querySelector('[data-setup-go]');
  var lbl = go.querySelector('[data-setup-lbl]'), sep = go.querySelector('[data-setup-sep]'), tot = go.querySelector('[data-setup-tot]');
  var st = box.querySelector('[data-setup-status] span'), added = {}, raf = 0, T = 0, busy = false, vars = [];
  var sv = 0;
  function pub(n, o) { var A = window.Shopify && Shopify.analytics; if (A && A.publish) try { A.publish(n, o); } catch (x) {} }
  try { vars = JSON.parse(root.querySelector('[data-pdpv9-variants]').textContent) || []; } catch (e) {}
  function main() {
    var inp = root.querySelector('[data-variant-input]'), id = inp ? +inp.value : 0, v = null;
    for (var i = 0; i < vars.length; i++) if (vars[i].id === id) v = vars[i];
    var q = root.querySelector('[data-qty-input]'), n = q ? Math.max(1, Math.min(99, parseInt(q.value, 10) || 1)) : 1;
    return { id: id, n: n, price: v ? v.price : 0, ok: !!(v && v.available) && !added[id] };
  }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function ticked() { return [].filter.call(box.querySelectorAll('.setup-cb'), function (c) { return c.checked; }); }
  function plan() {
    var m = main(), t = ticked(), all = box.querySelectorAll('.setup-cb:not(:disabled)').length, sum = 0, items = [];
    /* F2 (gate, Hermes + Archimedes): extras first, main item LAST, so the pipe is the top line in the drawer. */
    t.forEach(function (c) { items.push({ id: +c.getAttribute('data-setup-id'), quantity: 1 }); sum += +c.getAttribute('data-setup-price'); });
    if (m.ok) { items.push({ id: m.id, quantity: m.n }); sum += m.price * m.n; }
    var text = !t.length && !m.ok ? 'Tick an item to add' : !m.ok ? 'Add extras to cart' : t.length === all ? 'Add all to cart' : 'Add selected';
    return { items: t.length || m.ok ? items : [], text: text, sum: sum };
  }
  function paint() {
    raf = 0; if (busy || go.hasAttribute('data-state')) return;
    var p = plan(), none = !p.items.length;
    lbl.textContent = p.text; tot.textContent = none ? '' : money(p.sum);
    sep.hidden = none; tot.hidden = none;
    if (none) go.setAttribute('aria-disabled', 'true'); else go.removeAttribute('aria-disabled');
  }
  function soon() { if (!raf) raf = requestAnimationFrame(paint); }
  /* Tiresias T3: the status line is cleared before each add and again 2.2 s after, so a repeat add is announced again. */
  function later() { clearTimeout(T); T = setTimeout(function () { go.removeAttribute('data-state'); if (st) st.textContent = '\u00a0'; paint(); }, 2200); }
  box.addEventListener('change', soon);
  var buy = root.querySelector('.buy') || root;
  buy.addEventListener('change', soon); buy.addEventListener('click', soon);
  d.addEventListener('variant:add', function (e) {
    var x = e.detail || {}; if (x.source === 'pdpv9' && x.variant) { added[+x.variant.id] = 1; soon(); }
  });
  go.addEventListener('click', function () {
    if (busy || go.getAttribute('aria-disabled') === 'true') return;
    var p = plan(); if (!p.items.length) return;
    var dr = d.querySelector('cart-drawer'), m = main(), body = { items: p.items }, tk = ticked(), ns = box.querySelectorAll('.setup-cb:not(:disabled)').length;
    if (dr && typeof dr.getSectionsToRender === 'function') { body.sections = dr.getSectionsToRender().map(function (s) { return s.id; }).join(','); body.sections_url = location.pathname; }
    clearTimeout(T); go.removeAttribute('data-state'); busy = true; go.setAttribute('aria-busy', 'true');
    lbl.textContent = 'Adding'; sep.hidden = true; tot.hidden = true; if (st) st.textContent = '\u00a0';
    window.__tpwCartHandled = Date.now();
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (x) {} if (!r.ok || !j) throw 0; return j; }); })
      .then(function (j) {
        busy = false; go.removeAttribute('aria-busy'); go.setAttribute('data-state', 'added'); lbl.textContent = 'Added';
        if (m.ok) added[m.id] = 1;
        if (st) st.textContent = 'Added to cart';
        window.__tpwCartHandled = Date.now();
        try { d.dispatchEvent(new CustomEvent('tps:src', { detail: 'setup' })); } catch (x) {}
        pub('setup_add', { hs: tk.map(function (c) { return c.getAttribute('data-h'); }), ps: tk.map(function (c) { return cbs.indexOf(c) + 1; }), nt: tk.length, ns: ns, m: +m.ok });
        var secs = j.sections, ok = secs && dr && typeof dr.renderContents === 'function' && typeof dr.getSectionsToRender === 'function' &&
          dr.getSectionsToRender().every(function (s) { return typeof secs[s.id] === 'string' && secs[s.id] !== ''; });
        if (ok) dr.renderContents(j);
        else fetch('/?sections=cart-icon-bubble,cart-drawer').then(function (r) { return r.json(); }).then(function (s) { if (dr && dr.renderContents) dr.renderContents({ sections: s }); }).catch(function () {});
        later();
      }, function () {
        busy = false; go.removeAttribute('aria-busy'); go.setAttribute('data-state', 'fail'); lbl.textContent = 'Try again';
        if (st) st.textContent = 'Not added. Try again.';
        later();
      });
  });
  /* In cart (release 1 gate, open item 3): an extra already in the cart (added from the drawer rail, an earlier panel add,
     or a previous visit) is shown "In cart": unticked, disabled, never re-added, left out of the total; the button follows
     the usual rules. Re-read /cart.js (debounced, one call) on load and after any add or cart change; a line removed from
     the cart frees its row again (ticked, as on first render). A failed read changes nothing. */
  var cbs = [].slice.call(box.querySelectorAll('.setup-cb')), S = 0;
  cbs.forEach(function (c) { var p = c.parentNode.querySelector('.setup-p'); c._p = p ? p.textContent : ''; c._l = c.getAttribute('aria-label'); });
  function mark(ids) {
    cbs.forEach(function (c) {
      var inc = ids[+c.getAttribute('data-setup-id')] === 1, was = c.disabled, p = c.parentNode.querySelector('.setup-p');
      if (inc === was) return;
      c.disabled = inc; c.checked = !inc;
      c.parentNode.classList.toggle('is-in', inc);
      if (p) p.textContent = inc ? 'In cart' : c._p;
      c.setAttribute('aria-label', inc ? c._l.replace(/, [^,]*$/, '') + ', in cart' : c._l);
    });
    soon();
  }
  function sync() {
    clearTimeout(S); S = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (c) { var ids = {}; (c.items || []).forEach(function (i) { ids[i.variant_id] = 1; }); mark(ids); })
        .catch(function () {});
    }, 350);
  }
  d.addEventListener('tps:src', sync); d.addEventListener('variant:add', sync); d.addEventListener('cart:refresh', sync);
  try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, sync); } catch (x) {}
  sync();
  /* H3 (Hermes, release 1 gate): while the panel is on screen the sticky Add to cart bars (phone .mbar, desktop .dbar)
     step away, so "Add all" and a pipe-only "Add to cart" never show at once. pdpv9.js (QA-frozen) is untouched: one
     body class, CSS does the rest (transform slide + visibility after it, so the hidden bar leaves the tab order). */
  if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { var i = e[e.length - 1].isIntersecting; d.body.classList.toggle('tps-setup-in', i); if (i && !sv++) pub('setup_view', { n: cbs.length }); }).observe(box);
  paint();
})(document);
